<template>
  <div class="grid grid-cols-2 gap-5 mt-5 md:grid-cols-3" v-if="loading">
    <SkeletonLoader />
    <SkeletonLoader />
    <div class="hidden md:flex">
      <SkeletonLoader />
    </div>
  </div>
  <div v-else>
    <div v-if="projects">
      <div
        class="grid grid-cols-2 md:gap-x-10 gap-5 md:gap-y-[60px] md:grid-cols-3"
      >
        <a
          v-for="project in projects"
          :key="project.id"
          :href="
            $router.resolve({
              name: 'ProjectView',
              params: {
                id: project.id,
                slug: project.title ? $sanitizeTitle(project.title) : '',
              },
            }).href
          "
          class="relative flex flex-col border rounded-xl md:w-full"
        >
          <img
            :src="project.photos[0]"
            class="rounded-t-xl md:h-[183px]"
            alt=""
          />
          <div class="absolute top-0 left-0 mt-2 ml-2">
            <p
              class="w-auto h-auto px-2 text-[9px] text-white uppercase bg-stone-900 rounded opacity-80"
            >
              {{ project.completion_status }}
            </p>
          </div>
          <div class="flex flex-col flex-grow p-2 space-y-2 bg-white">
            <span
              v-if="project.delivery_date"
              class="text-primary bg-[#F7F6FB] text-[11px] p-1 rounded-full font-semibold w-32 flex justify-center items-center"
              >Delivery Date
              {{ getQuarterWithYear(project.delivery_date) }}</span
            >
            <p class="overflow-hidden text-xl font-semibold truncate text-clip">
              {{ project.title }}
            </p>
            <p class="text-sm font-semibold">
              From
              <span class="font-normal">{{
                formattedAmount(Number(project.price))
              }}</span>
            </p>
            <p class="text-sm font-semibold">
              Developer:
              <span class="overflow-hidden font-normal">{{
                project.company.name
              }}</span>
            </p>
            <div>
              <p class="text-[11px] text-stone-500 overflow-hidden text-clip">
                {{ project.city.name }}, {{ project.address }}, Ghana
              </p>
            </div>
          </div>
          <hr class="mt-auto" />
          <div class="flex justify-between p-2 space-x-2 md:space-x-5">
            <a
              :href="
                'mailto:' +
                project.company.email +
                '?subject=New Project  &body=I want to find out more about this property.'
              "
              class="text-primary py-1 px-2 md:py-2 md:px-3 rounded-lg hover:transition duration-200 ease-in-out w-full bg-[#f7f6fb] hover:bg-[#E3E1F2] flex items-center font-medium text-sm justify-center"
            >
              <EmailSvg color="primary" height="4" width="4" />
              <span class="ml-1 text-[10px] md:text-sm">Email</span>
            </a>
            <a
              target="__blank"
              :href="
                'https://wa.me/' +
                project.company.phone +
                '?text=I want to find out more about this property'
              "
              class="text-primary md:py-2 md:px-3 px-1 rounded-lg hover:transition duration-200 ease-in-out w-full bg-[#f7f6fb] hover:bg-[#E3E1F2] flex items-center font-medium text-sm justify-center"
            >
              <WhatsAppSvg color="primary" height="4" width="4" />
              <span class="ml-1 text-[10px] md:text-sm">WhatsApp</span>
            </a>
          </div>
        </a>
      </div>
    </div>
    <div
      v-else-if="projects.length <= 0"
      class="md:w-[825px] mt-10 flex justify-center items-center"
    >
      <p class="text-xl text-stone-500">No Projects</p>
    </div>
  </div>
</template>
<script>
import EmailSvg from "@/components/svg/EmailSvg.vue";
import WhatsAppSvg from "@/components/svg/WhatsAppSvg.vue";
import SkeletonLoader from "@/components/SkeletonLoader.vue";
export default {
  props: {
    projects: Object,
  },
  components: {
    EmailSvg,
    WhatsAppSvg,
    SkeletonLoader,
  },
  data() {
    return {
      loading: true,
    };
  },
  watch: {
    projects: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length >= 0) {
          // Wait for 1 second before setting loading to false
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      },
    },
  },
  methods: {
    getQuarterWithYear(date) {
      const quarter = Math.floor((new Date(date).getMonth() + 3) / 3);
      const year = new Date(date).getFullYear();
      return "Q" + quarter + " " + year;
    },
  },
};
</script>
